import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode, resolveDirective as _resolveDirective, createBlock as _createBlock, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-a6ff5c76"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "auth-page" }
const _hoisted_2 = { class: "type-selector" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "type-selector-label" }, "主体类型", -1))
const _hoisted_4 = { class: "type-selector-options" }
const _hoisted_5 = ["onClick"]
const _hoisted_6 = { class: "type-card-name" }
const _hoisted_7 = { class: "type-card-desc" }
const _hoisted_8 = { class: "name-input-row" }
const _hoisted_9 = {
  key: 0,
  class: "name-result"
}
const _hoisted_10 = {
  key: 0,
  class: "result-error"
}
const _hoisted_11 = {
  key: 1,
  class: "result-warning"
}
const _hoisted_12 = {
  key: 2,
  class: "result-success"
}
const _hoisted_13 = ["src"]
const _hoisted_14 = {
  key: 1,
  class: "upload-placeholder"
}
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  viewBox: "0 0 1024 1024",
  class: "upload-icon"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    d: "M544 864V288l264 264 60-60-368-368-368 368 60 60 264-264v576h88z",
    fill: "currentColor"
  })
], -1))
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "请上传营业执照", -1))
const _hoisted_17 = [
  _hoisted_15,
  _hoisted_16
]
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "submit-fixed-wrap-placeholder" }, null, -1))
const _hoisted_19 = { class: "submit-fixed-wrap" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ui_title = _resolveComponent("ui-title")!
  const _component_ui_tabbar2 = _resolveComponent("ui-tabbar2")!
  const _component_ui_form_item = _resolveComponent("ui-form-item")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_ui_card = _resolveComponent("ui-card")!
  const _component_ui_form = _resolveComponent("ui-form")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_ui_form, {
      ref: "form",
      "label-position": "right",
      "label-width": "140px"
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_2, [
          _hoisted_3,
          _createElementVNode("div", _hoisted_4, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.customerList, (item) => {
              return (_openBlock(), _createElementBlock("div", {
                key: item.value,
                class: _normalizeClass(["type-card", { selected: _ctx.formData.auth_data.customer_type === item.value }]),
                onClick: ($event: any) => (_ctx.formData.auth_data.customer_type = item.value)
              }, [
                _createElementVNode("div", _hoisted_6, _toDisplayString(item.name), 1),
                _createElementVNode("div", _hoisted_7, _toDisplayString(item.desc), 1)
              ], 10, _hoisted_5))
            }), 128))
          ])
        ]),
        _createVNode(_component_ui_card, null, {
          title: _withCtx(() => [
            _createVNode(_component_ui_title, { title: "小程序信息" })
          ]),
          default: _withCtx(() => [
            _createVNode(_component_ui_form_item, {
              label: "名称命名类型",
              required: true
            }, {
              default: _withCtx(() => [
                _createVNode(_component_ui_tabbar2, {
                  modelValue: _ctx.formData.auth_data.account_name_type,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.formData.auth_data.account_name_type) = $event)),
                  list: [{ name: '基于自选词汇命名', value: 1 }, { name: '基于商标命名', value: 2 }]
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_ui_form_item, {
              label: "小程序名称",
              data: _ctx.formData.auth_data.account_name,
              required: true
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", null, [
                  _createElementVNode("div", _hoisted_8, [
                    _createVNode(_component_el_input, {
                      modelValue: _ctx.formData.auth_data.account_name,
                      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.formData.auth_data.account_name) = $event)),
                      placeholder: "请输入小程序名称，请注意这是一次改名机会，也可用不修改"
                    }, null, 8, ["modelValue"]),
                    _createVNode(_component_el_button, {
                      type: "primary",
                      onClick: _ctx.checkName
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode("检查名称")
                      ]),
                      _: 1
                    }, 8, ["onClick"])
                  ]),
                  (_ctx.nameResult)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                        (_ctx.nameResult.type == 'error')
                          ? (_openBlock(), _createElementBlock("div", _hoisted_10, _toDisplayString(_ctx.nameResult.message), 1))
                          : (_ctx.nameResult.data.hit_condition)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_11, _toDisplayString(_ctx.nameResult.data.wording), 1))
                            : (_openBlock(), _createElementBlock("div", _hoisted_12, "恭喜该名称可用"))
                      ]))
                    : _createCommentVNode("", true)
                ])
              ]),
              _: 1
            }, 8, ["data"]),
            _createVNode(_component_ui_form_item, {
              label: "主体资质材料",
              required: true
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", {
                  class: "upload-zone",
                  onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.uploadFiles('auth_data.qualification')))
                }, [
                  (_ctx.showData[_ctx.formData.auth_data.qualification])
                    ? (_openBlock(), _createElementBlock("img", {
                        key: 0,
                        src: _ctx.showData[_ctx.formData.auth_data.qualification],
                        class: "upload-preview"
                      }, null, 8, _hoisted_13))
                    : (_openBlock(), _createElementBlock("div", _hoisted_14, _hoisted_17))
                ])
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _createVNode(_component_ui_card, null, {
          title: _withCtx(() => [
            _createVNode(_component_ui_title, { title: "发票信息" })
          ]),
          default: _withCtx(() => [
            _createVNode(_component_ui_form_item, { label: "开票信息" }, {
              default: _withCtx(() => [
                _createVNode(_component_ui_tabbar2, {
                  list: _ctx.invoiceList,
                  modelValue: _ctx.formData.auth_data.invoice_info.invoice_type,
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.formData.auth_data.invoice_info.invoice_type) = $event))
                }, null, 8, ["list", "modelValue"])
              ]),
              _: 1
            }),
            (_ctx.formData.auth_data.invoice_info.invoice_type == 2)
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                  _createVNode(_component_ui_form_item, {
                    label: "纳税识别号",
                    data: _ctx.formData.auth_data.invoice_info.electronic.id,
                    required: true
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_input, {
                        modelValue: _ctx.formData.auth_data.invoice_info.electronic.id,
                        "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.formData.auth_data.invoice_info.electronic.id) = $event)),
                        placeholder: "请输入纳税人识别号"
                      }, null, 8, ["modelValue"])
                    ]),
                    _: 1
                  }, 8, ["data"]),
                  _createVNode(_component_ui_form_item, { label: "发票备注" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_input, {
                        modelValue: _ctx.formData.auth_data.invoice_info.electronic.desc,
                        "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.formData.auth_data.invoice_info.electronic.desc) = $event)),
                        placeholder: "请输入发票备注"
                      }, null, 8, ["modelValue"])
                    ]),
                    _: 1
                  })
                ], 64))
              : _createCommentVNode("", true)
          ]),
          _: 1
        }),
        _createVNode(_component_ui_card, null, {
          title: _withCtx(() => [
            _createVNode(_component_ui_title, { title: "联系人信息" })
          ]),
          default: _withCtx(() => [
            _createVNode(_component_ui_form_item, {
              label: "联系人姓名",
              data: _ctx.formData.auth_data.contact_info.name,
              required: true
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  modelValue: _ctx.formData.auth_data.contact_info.name,
                  "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.formData.auth_data.contact_info.name) = $event)),
                  placeholder: "请输入联系人姓名"
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }, 8, ["data"]),
            _createVNode(_component_ui_form_item, {
              label: "联系人邮箱",
              data: _ctx.formData.auth_data.contact_info.email,
              required: true
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  modelValue: _ctx.formData.auth_data.contact_info.email,
                  "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.formData.auth_data.contact_info.email) = $event)),
                  placeholder: "请输入联系人邮箱"
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }, 8, ["data"])
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 512),
    _hoisted_18,
    _createElementVNode("div", _hoisted_19, [
      _withDirectives((_openBlock(), _createBlock(_component_el_button, {
        onClick: _ctx.submit,
        type: "primary",
        size: "large"
      }, {
        default: _withCtx(() => [
          _createTextVNode("提交信息")
        ]),
        _: 1
      }, 8, ["onClick"])), [
        [_directive_loading, _ctx.submitLoading]
      ])
    ])
  ]))
}